/**
 * Configuração de Parceiro - Telecom Plus
 * 
 * Este arquivo representa a configuração completa de um parceiro white-label.
 * Herda a estrutura completa do config padrão e sobrescreve apenas o necessário.
 * 
 * Nome do Parceiro: Telecom Plus
 * ID: telecomplus
 */

import defaultConfig from '../config';
import defaultTexts from '../texts';
import defaultContent from '../content';
import defaultImages from '../images';
import defaultLinks from '../links';

export default {
  // ============ IDENTIFICAÇÃO DO PARCEIRO ============
  client: {
    id: 'telecomplus',
    name: 'Telecom Plus',
    slug: 'telecomplus',
    active: true,
    createdAt: '2026-01-29',
    domain: 'telecomplus.com.br',
  },

  // ============ CORES DO TEMA ============
  colors: {
    primary: {
      main: '#FF6B00',      // Laranja
      light: '#FF8F3D',
      dark: '#CC5500',
      gradient: 'linear-gradient(135deg, #FF6B00 0%, #FF8F3D 100%)',
    },
    secondary: {
      blue: '#0066CC',
      green: '#00CC66',
      purple: '#6B00FF',
      gradient: 'linear-gradient(135deg, #0066CC 0%, #00CC66 100%)',
    },
    neutral: defaultConfig.colors.neutral,
  },

  // ============ INFORMAÇÕES DA EMPRESA ============
  company: {
    name: 'Telecom Plus',
    slogan: 'Conectividade que impulsiona seu negócio',
    description: 'A Telecom Plus é uma empresa de telecomunicações inscrita no CNPJ 123.456.789/0001-00 com licença SCM da Anatel.',
    copyright: '© 2026 Telecom Plus. Todos os direitos reservados.',
    cnpj: '123.456.789/0001-00',
    razaoSocial: 'Telecom Plus Ltda',
  },

  // ============ LOGOS E IMAGENS ============
  images: {
    ...defaultImages, // Herda TODAS as imagens do padrão
    logos: {
      // Sobrescreve apenas os logos
      main: 'https://via.placeholder.com/200x60/FF6B00/FFFFFF?text=TelecomPlus',
      white: 'https://via.placeholder.com/200x60/FFFFFF/FF6B00?text=TelecomPlus',
      icon: 'https://via.placeholder.com/64x64/FF6B00/FFFFFF?text=TP',
      favicon: '/favicon-telecomplus.ico',
    },
    // Mantém banners, ofertas, planoControle, telefoniaBanner, etc. do defaultImages
  },

  // ============ LINKS E CONTATOS ============
  // Herda toda estrutura de links do defaultLinks (routes, menu, etc)
  // e sobrescreve apenas social, external, phones e emails personalizados
  links: {
    ...defaultLinks,
    social: {
      ...defaultLinks.social,
      facebook: {
        ...defaultLinks.social.facebook,
        url: 'https://facebook.com/telecomplus',
      },
      instagram: {
        ...defaultLinks.social.instagram,
        url: 'https://instagram.com/telecomplus',
        username: '@telecomplus',
      },
      whatsapp: {
        ...defaultLinks.social.whatsapp,
        url: 'https://wa.me/5511999999999',
        phone: '5511999999999',
        displayPhone: '11 99999-9999',
      },
    },
    external: {
      ...defaultLinks.external,
      centralAssinante: 'https://central.telecomplus.com.br',
      recargaCelular: 'https://recarga.telecomplus.com.br',
      assineAgora: 'https://assine.telecomplus.com.br',
    },
    phones: {
      ...defaultLinks.phones,
      support: '08001234567',
      supportFormatted: '0800 123 4567',
      whatsapp: {
        number: '5511999999999',
        display: '11 99999-9999',
        tel: 'tel:5511999999999',
      },
    },
  },

  // ============ TEXTOS PERSONALIZADOS ============
  texts: {
    ...defaultTexts,
    company: {
      name: 'Telecom Plus',
      slogan: 'Conectividade que impulsiona seu negócio',
      description: 'A Telecom Plus é uma empresa de telecomunicações inscrita no CNPJ 123.456.789/0001-00 com licença SCM da Anatel.',
      copyright: '© 2026 Telecom Plus. Todos os direitos reservados.',
    },
    footer: {
      ...defaultTexts.footer,
      location: {
        label: 'Você está em:',
        city: 'São Paulo - SP',
      },
    },
  },

  // ============ CONTEÚDO DINÂMICO ============
  content: {
    ...defaultContent,
    ofertas: defaultContent.ofertas.map(oferta => ({
      ...oferta,
      header: 'Plano Empresarial',
      price: oferta.price * 0.9, // 10% desconto para Telecom Plus
    })),
    depoimentos: [
      {
        id: 1,
        name: 'Carlos Silva',
        location: 'São Paulo - SP',
        rating: 5,
        text: 'Excelente serviço! A Telecom Plus transformou nossa conectividade.',
        date: '2026-01-15',
      },
      {
        id: 2,
        name: 'Ana Paula',
        location: 'São Paulo - SP',
        rating: 5,
        text: 'Atendimento excepcional e internet ultra rápida!',
        date: '2026-01-20',
      },
    ],
  },

  // ============ CONFIGURAÇÃO DE PÁGINAS ============
  pages: defaultConfig.pages,

  // ============ COMPONENTES POR PÁGINA ============
  components: defaultConfig.components,

  // ============ SEO E METADATA ============
  seo: {
    title: 'Telecom Plus - Conectividade Empresarial',
    description: 'Soluções em telecomunicações para empresas. Internet fibra óptica de alta velocidade.',
    keywords: 'internet empresarial, fibra óptica, telecom plus, são paulo',
    ogImage: '/og-telecomplus.jpg',
    themeColor: '#FF6B00',
    favicon: '/favicon-telecomplus.ico',
  },

  // ============ FEATURES ============
  features: defaultConfig.features,

  // ============ API ============
  api: defaultConfig.api,

  // ============ LAYOUT ============
  layout: defaultConfig.layout,

  // ============ FORMS ============
  forms: defaultConfig.forms,

  // ============ ECOMMERCE ============
  ecommerce: defaultConfig.ecommerce,

  // ============ ANALYTICS ============
  analytics: defaultConfig.analytics,

  // ============ INTEGRATIONS ============
  integrations: {
    ...defaultConfig.integrations,
    whatsapp: {
      enabled: true,
      number: '5511999999999',
      message: 'Olá Telecom Plus! Gostaria de mais informações.',
    },
  },

  // ============ LOCALE ============
  locale: defaultConfig.locale,
};
